import React from "react";
import './Contact.css'
import { useContext } from "react";
import { themeContext } from "../../Context";

export const Contact=()=>{
  
        const theme=useContext(themeContext);
        const darkMode=theme.state.darkMode;

    return(
        <div className="contact-form" id="Contact">
            <div className="w-left">
            <h2 style={{color:darkMode?'white':'', fontSize: '40px'}} >Get in Touch</h2>
                    <span>Details</span>
                    <div className="c-right">
                    
                    <div className="blur s-blur1" style={{background:"#ABF1FF94"}}></div>
                      <div className="sm">  <div >Name : Sushmita Majumder</div>
                        <div >Contact Number : 6009031334</div>
                        
                        <div >Whatsapp Number : 6009031334</div>
                        <div>Email : missbinarybeauty456@gmail.com</div>
                        <div>Github : <a href="https://github.com/binarybeauty45" target='_blank'>binarybeauty45</a>
                        <div>Linkedin :<a href="https://www.linkedin.com/in/binarybeauty45/" target='_blank'>Sushmita Majumder</a></div></div>
                        <div className="blur s-blur1" style={{background:"rgb(119, 214, 211)"}}></div>
                    </div></div>
                    <div className="blur s-blur1" style={{background:"#ABF1FF94"}}></div>
                </div>
              
            </div>
           

    )
}
export default Contact;